import gqlTagGira from 'graphql-tag';

export const LABELS_FRAGMENT = gqlTagGira`
    fragment jiraLabelsFieldFragment on JiraLabelsField {
        selectedLabelsConnection {
            edges {
                node {
                    name
                }
            }
        }
    } 
`;
